import { render, staticRenderFns } from "./BotaoBannerUpgrade.vue?vue&type=template&id=48550952&scoped=true&"
import script from "./BotaoBannerUpgrade.vue?vue&type=script&lang=js&"
export * from "./BotaoBannerUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./BotaoBannerUpgrade.vue?vue&type=style&index=0&id=48550952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48550952",
  null
  
)

export default component.exports